@if (searchOpen()) {
  <app-match-search-mobile-panel id="mobile-search-panel" (dismissed)="dismissSearch()"></app-match-search-mobile-panel>
} @else if (summary().selectionCount > 0) {
  <div class="mobile-shortcuts__betslip">
    <div class="mobile-shortcuts__betslip-inner">
      @if (bonusVisible() ? bonusHint() : null; as hint) {
        <aside class="mobile-shortcuts__bonus"
          (mouseenter)="setBonusHovered(true)" (mouseleave)="setBonusHovered(false)"
          (focusin)="setBonusFocused(true)" (focusout)="setBonusFocused(false)">
          <span class="material-symbols-outlined mobile-shortcuts__bonus-icon" aria-hidden="true">bolt</span>
          <span class="mobile-shortcuts__bonus-text" role="status">
            {{ (hint.missingMatches === 1 ? 'mobileShortcuts.bonusHintOne' : 'mobileShortcuts.bonusHintMany') | translate: {
              count: hint.missingMatches, odds: (hint.minOdds | number: '1.1-2'), bonus: (hint.bonusPercent | number: '1.0-2')
            } }}
          </span>
          <button type="button" class="mobile-shortcuts__bonus-close"
            [attr.aria-label]="'mobileShortcuts.dismissBonus' | translate" (click)="dismissBonus(true)">
            <span class="material-symbols-outlined" aria-hidden="true">close</span>
          </button>
        </aside>
      }
      <app-betslip-mobile-widget [summary]="summary()" [maxWinPulseKey]="maxWinPulseKey()"
        (open)="openBetSlip.emit()"></app-betslip-mobile-widget>
    </div>
  </div>
}

<nav class="mobile-shortcuts" [class.mobile-shortcuts--extended]="searchOpen() || summary().selectionCount > 0"
  [attr.aria-label]="'mobileShortcuts.label' | translate">
  <div class="mobile-shortcuts__items">
    <button type="button" class="mobile-shortcuts__item" disabled>
      <span class="material-symbols-outlined" aria-hidden="true">add_circle</span>
      <span>{{ 'mobileShortcuts.deposit' | translate }}</span>
      <span class="sr-only">{{ 'mobileShortcuts.comingSoon' | translate }}</span>
    </button>
    <button type="button" class="mobile-shortcuts__item" disabled>
      <span class="material-symbols-outlined" aria-hidden="true">grid_view</span>
      <span>{{ 'mobileShortcuts.tournaments' | translate }}</span>
      <span class="sr-only">{{ 'mobileShortcuts.comingSoon' | translate }}</span>
    </button>
    <button #liveButton type="button" class="mobile-shortcuts__item mobile-shortcuts__item--live"
      [class.mobile-shortcuts__item--current]="liveActive()" [attr.aria-pressed]="liveActive()" (click)="openLive.emit()">
      <span class="material-symbols-outlined" aria-hidden="true">sensors</span>
      <span>{{ 'mobileShortcuts.live' | translate }}</span>
    </button>
    <button #searchButton type="button" class="mobile-shortcuts__item"
      [class.mobile-shortcuts__item--filtered]="searchEnabled() && searchQuery().trim().length > 0"
      [disabled]="!searchEnabled()" [attr.aria-expanded]="searchOpen()"
      [attr.aria-controls]="searchOpen() ? 'mobile-search-panel' : null" (click)="toggleSearch.emit()">
      <span class="material-symbols-outlined" aria-hidden="true">search</span>
      <span>{{ 'mobileShortcuts.search' | translate }}</span>
      @if (searchEnabled() && searchQuery().trim().length > 0) {
        <span class="sr-only">{{ 'mobileShortcuts.activeSearch' | translate: { query: searchQuery() } }}</span>
      }
    </button>
    <a class="mobile-shortcuts__item" routerLink="/tickets" routerLinkActive="mobile-shortcuts__item--current" ariaCurrentWhenActive="page">
      <span class="material-symbols-outlined" aria-hidden="true">confirmation_number</span>
      <span>{{ 'menu.myTickets' | translate }}</span>
    </a>
  </div>
</nav>
